module.exports = __webpack_public_path__ + "img/bill.7e575118.jpg";